export const CODING_DEFAULT_DATA = {
    question_id: null,
    question_index: null,
    editor_instance_key: '',
    question_title: '',
    question_description: '',
    sample_data: [],
    hints: [],
    time_estimate: 1800,
    programming_language: 'javascript',
    coding_question: '',
    difficulty: 'easy',
};
